import React from "react"
import { motion } from "framer-motion"
import { MapPin, Phone, Mail, MessageCircle, Send, Facebook, Twitter, Instagram, Linkedin } from "lucide-react"
import Back from "../common/back/Back"
import "./contact.css"
import SEO from "../common/SEO"

const Contact = () => {
  const map = "https://maps.google.com/maps?q=30.210225,74.945490&z=21&output=embed"

  const contactInfo = [
    {
      icon: <MapPin className="contact-icon" />,
      label: "ADDRESS",
      value: "Welsh Education near Bus Stand, Opp. Power House Road Lights, Bathinda, Punjab-151001",
    },
    {
      icon: <Phone className="contact-icon" />,
      label: "CALL US",
      value: "+91 91154-00982, +91 98884-08200",
    },
    {
      icon: <Mail className="contact-icon" />,
      label: "EMAIL",
      value: "info@welsheducation.com",
    },
    {
      icon: <MessageCircle className="contact-icon" />,
      label: "WHATSAPP",
      value: "Chat Support Available 24/7",
      link: "https://wa.me/9115400982"
    },
  ]

  return (
    <>
      <SEO
        title="Contact Us - Welsh Education Group"
        description="Get in touch with Welsh Education Group for world-class consultancy."
        url="/contact"
      />
      <Back title="Get In Touch" />

      <section className="contact-page-section">
        <div className="container">
          <div className="contact-wrapper">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="contact-left"
            >
              <div className="map-container">
                <iframe
                  src={map}
                  title="location map"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>

              <div className="contact-grid">
                {contactInfo.map((item, idx) => (
                  <div key={idx} className="contact-card">
                    <div className="icon-wrapper">{item.icon}</div>
                    <div className="card-text">
                      <h5>{item.label}</h5>
                      {item.link ? (
                        <a href={item.link} target="_blank" rel="noreferrer">{item.value}</a>
                      ) : (
                        <p>{item.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="contact-right"
            >
              <div className="form-header">
                <span className="form-badge">Send Message</span>
                <h2>Have Any Questions?</h2>
                <p>Feel free to reach out. Our experts are here to guide you.</p>
              </div>

              <form className="futuristic-form">
                <div className="input-row">
                  <div className="input-group">
                    <input type="text" placeholder="Full Name" required />
                  </div>
                  <div className="input-group">
                    <input type="email" placeholder="Email Address" required />
                  </div>
                </div>
                <div className="input-group">
                  <input type="text" placeholder="Subject" />
                </div>
                <div className="input-group">
                  <textarea rows="5" placeholder="Your Message..."></textarea>
                </div>
                <button type="submit" className="submit-btn highlight-glow">
                  Send Message <Send size={18} />
                </button>
              </form>

              <div className="social-connect">
                <h5>Follow Our Journey</h5>
                <div className="social-links">
                  <a href="#"><Facebook size={20} /></a>
                  <a href="#"><Twitter size={20} /></a>
                  <a href="#"><Instagram size={20} /></a>
                  <a href="#"><Linkedin size={20} /></a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
